import type { Side } from '../../../shared/types';

/** "You play White" / "You play Black" — the single most important fact about
 *  an opening entry, so it gets a badge rather than body text. */
export default function SideBadge({ side }: { side: Side }) {
  return (
    <span className={`side-badge side-badge--${side}`}>
      <span className="side-badge-dot" aria-hidden="true" />
      {side === 'white' ? 'White' : 'Black'}
    </span>
  );
}
